<template>
  <div class="warehouse-card" :class="{'is-default': isDefault}">
    <div class="card-header" @click="toggleExpand">
      <span class="warehouse-icon">{{ isDefault ? '🏪' : '📍' }}</span>
      <span class="warehouse-title">
        {{ isDefault ? '店铺仓库（默认）' : (warehouse.name || '仓库' + (index + 1)) }}
      </span>
      <span class="expand-icon">{{ warehouse.isExpanded ? '▼' : '▶' }}</span>
      <button v-if="canDelete" class="btn-delete" @click.stop="deleteWarehouse">×</button>
    </div>

    <div v-if="warehouse.isExpanded" class="card-body">
      <div class="form-item">
        <label>仓库名称</label>
        <input 
          v-if="!isDefault"
          type="text" 
          v-model="warehouse.name"
          placeholder="请输入仓库名称（如：分仓库）"
          @input="notifyUpdate"
        />
        <input 
          v-else
          type="text" 
          value="店铺仓库（默认）"
          disabled
          class="input-disabled"
        />
      </div>

      <div class="form-item">
        <label>库存</label>
        <input 
          type="number" 
          v-model.number="warehouse.stockQuantity"
          @input="notifyUpdate"
        />
      </div>

      <div v-if="isDefault" class="default-hint">
        ✅ 第 1 个仓库，不可删除
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WarehouseCard',
  
  props: {
    warehouse: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    isDefault: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  
  emits: ['update', 'delete'],
  
  methods: {
    toggleExpand() {
      this.$emit('update', this.warehouse.id, {
        isExpanded: !this.warehouse.isExpanded
      });
    },

    notifyUpdate() {
      this.$emit('update', this.warehouse.id, {
        name: this.warehouse.name,
        stockQuantity: this.warehouse.stockQuantity
      });
    },

    deleteWarehouse() {
      if (confirm('确定要删除这个仓库吗？')) {
        this.$emit('delete', this.warehouse.id);
      }
    }
  }
};
</script>

<style scoped>
.warehouse-card {
  margin-bottom: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s;
}

.warehouse-card.is-default {
  border-color: #86efac;
  background: #f0fdf4;
}

.warehouse-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-header {
  padding: 16px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.card-header:hover {
  background: #f9fafb;
}

.warehouse-icon {
  font-size: 20px;
}

.warehouse-title {
  flex: 1;
  font-weight: 600;
  font-size: 15px;
  color: #111827;
}

.expand-icon {
  color: #9ca3af;
  font-size: 12px;
}

.btn-delete {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fee2e2;
  color: #ef4444;
  border: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
}

.btn-delete:hover {
  background: #fecaca;
  transform: scale(1.1);
}

.card-body {
  padding: 16px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
}

.form-item {
  margin-bottom: 16px;
}

.form-item:last-child {
  margin-bottom: 0;
}

.form-item label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.form-item input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.form-item input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.input-disabled {
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.default-hint {
  margin-top: 12px;
  padding: 8px 12px;
  background: #dcfce7;
  border-radius: 6px;
  font-size: 13px;
  color: #15803d;
  font-weight: 500;
}
</style>
